import { Button, Card, Icon, Input, Modal, Select, Table, Carousel } from '@scuf/common';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { COMPANY_MANAGER, LOB, SPARE_PARTS, USER_MODULE, companyAtom, companyDtoAtom } from 'resources';
import { orderCartAtom } from 'resources/atoms/spareParts';
import MyCart from './MyCart';
import { OrderCartDTO, OrderItemsDTO, ProductsDTO } from 'models/spareParts/orderById';
import useFetch from 'helpers/hooks/useFetch';
import useUser from 'helpers/hooks/useUser';
import { CompanyDTO, CompanyLOBDTO, LobDto, SearchLob } from 'models/userManager/addCustomer';
import 'styles/spareParts.scss';
import { colors } from '@bigheads/core/dist/theme';
import { notificationAtom } from 'resources';

export type StepperProp = {
    canSkipPage: (goNext: boolean) => void;
};

function AddEquipment({ canSkipPage }: StepperProp): JSX.Element {
    const { t } = useTranslation(['spareparts', 'common', 'user', 'notification']);
    const [loading, setLoading] = useState<boolean>(false);
    const [modalState, setModalState] = useState<boolean>(false);
    const [selected, setSelected] = useState<{ pn: string; pd: string[] }>({ pn: '', pd: [] });
    const [modalStateQuantity, setModalStateQuantity] = useState<boolean>(false);
    const [defaultCart, setdefaultCart] = useRecoilState<OrderCartDTO>(orderCartAtom);
    const [newQtd, setNewQtd] = useState<number>(0);
    const { user } = useUser();
    const [, setUserCompany] = useRecoilState<CompanyDTO>(companyAtom);
    const [permissions, setPermissions] = useState<string>('');
    const [partNumbers, setPartNumbers] = useState<ProductsDTO[]>();
    const [imgModalVisible, setIMGModalVisible] = useState<boolean>(false);
    const [images, setImages] = useState<string[]>([]);
    const [currentImageIndex, setCurrentImageIndex] = useState<number>(0);
    const [imagesMap, setImagesMap] = useState<{ [key: string]: string[] }>({});
    const [carregaImagem, setCarregaImagem] = useState<boolean>(false);
    const setNotification = useSetRecoilState(notificationAtom);
    const [imageLoading, setImageLoading] = useState(true);

    const setCompany = useSetRecoilState<CompanyDTO>(companyDtoAtom);

    const [lobs, getLobs] = useFetch<{ companyId: number }, CompanyLOBDTO[]>({
        url: USER_MODULE.getCompanyLOBs,
        onError: 'LoadInfo'
    });

    const [company, getCompanyById] = useFetch<{ id: number }, CompanyDTO>({
        url: COMPANY_MANAGER.getCompanyById,
        onError: 'LoadInfo'
    });

    const [products, getOptions, , updateProducts] = useFetch<never>({
        url: SPARE_PARTS.getOptions
    });

    const [allLobs, getAllLOBS] = useFetch<never, LobDto[]>({
        url: LOB.getLOBs,
        onError: 'LoadInfo'
    });

    const [, getAllPartnumberByLOB] = useFetch<{ lobs: string; product?: string[] }, any[]>({
        url: SPARE_PARTS.getAllPartNumbersByLOB,
        onError: 'LoadInfo'
    });

    const [resultList, SearchPartNumbers, loadAction, updatePn] = useFetch<any, OrderItemsDTO[]>({
        url: SPARE_PARTS.SearchPartNumbersMultiLOBS,
        onError: 'LoadInfo',
        method: 'POST'
    });

    const [, addItemInCart, loadingAdd] = useFetch<OrderItemsDTO, OrderItemsDTO>({
        url: SPARE_PARTS.addItemInCart,
        method: 'POST',
        onError: 'Add'
    });

    const [, fetchImages] = useFetch<string[], any>({
        url: SPARE_PARTS.getImages,
        method: 'POST',
        onError: t('notification:critical.ErroImage')
    });

    useEffect(() => {
        getCompanyById({ id: user?.company! }, resp => setCompany(resp.data!));
        getAllLOBS();
        handleGetPartNumbers();
    }, []);

    useEffect(() => {
        setUserCompany(company?.data!);
    }, [company]);

    useEffect(() => {
        if (permissions == '') return;

        getAllPartnumberByLOB({ lobs: permissions }, resp => {
            if (resp.data) {
                setPartNumbers(
                    resp.data?.map((x, index) => ({
                        value: index,
                        text: x.code
                    }))
                );
            }
        });
    }, [permissions]);

    useEffect(() => {
        if ((permissions === undefined || permissions === '') && (selected.pd === undefined || selected.pd.length === 0)) return;

        getAllPartnumberByLOB({ lobs: permissions, product: selected.pd }, resp => {
            if (resp.data) {
                setPartNumbers(
                    resp.data?.map((x, index) => ({
                        value: index,
                        text: x.code
                    }))
                );
            }
        });
    }, [selected]);

    useEffect(() => {
        const total = defaultCart?.orderItems?.reduce(
            (acc, current) => acc + (1 - current.discount) * current.netPrice * current.quantity,
            0
        );
        setdefaultCart(old => ({ ...old, total }));
        canSkipPage(defaultCart?.orderItems?.length > 0);
    }, [defaultCart?.orderItems]);

    useEffect(() => {
        if (lobs == undefined) return;

        let perms: string = '';
        let resp: CompanyLOBDTO[] = lobs.data as CompanyLOBDTO[];
        perms = resp[0].lob.lobCode;
        for (let cl of resp) perms += `,${cl.lob.lobCode}`;
        setPermissions(perms);
    }, [lobs]);

    useEffect(() => {
        if (user) getLobs({ companyId: user.company });
    }, [user]);

    const renderModal = (): JSX.Element => {
        return (
            <Modal
                onClose={() => setModalState(false)}
                size="large"
                open={modalState}
                closeOnDimmerClick={true}
                closeOnDocumentClick={true}
            >
                <div className="modalConsultWaranty">
                    <Modal.Header>
                        <div className="modalHeader">
                            <h2> {t('productinfots.FreeShipping')} </h2>
                        </div>
                    </Modal.Header>
                    <Modal>
                        <h2> {t('common:translation.Details')} </h2>
                    </Modal>
                    <Modal.Footer>
                        <Table>
                            <Table.Header>
                                <Table.HeaderCell content={t('user:address.State')} />
                                <Table.HeaderCell content={t('productinfots.MinimumPurchase')} />
                                <Table.HeaderCell content={t('productinfots.CostFreight')} />
                            </Table.Header>
                            <Table.Body>
                                <Table.Row>
                                    <Table.Cell>{'SP/MG'}</Table.Cell>
                                    <Table.Cell>{'USD 49,00'}</Table.Cell>
                                    <Table.Cell>{'USD 9,99'}</Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell>{t('productinfots.RestBrazil')}</Table.Cell>
                                    <Table.Cell>{t('USD 99,00')}</Table.Cell>
                                    <Table.Cell>{t('USD 17,99')}</Table.Cell>
                                </Table.Row>
                            </Table.Body>
                        </Table>
                    </Modal.Footer>
                    <div>
                        <h4>{t('productinfots.ValidPurchase')}</h4>
                    </div>

                    <Card.Footer>
                        <div className="buttonModal">
                            <Button
                                content={t('common:actions.Close')}
                                onClick={() => setModalState(false)}
                                size="medium"
                                textTransform={true}
                            />
                        </div>
                    </Card.Footer>
                </div>
            </Modal>
        );
    };

    const handleSearch = async () => {
        const listLOBPermitted: string[] = permissions.split(',');
        const selLOBS: LobDto[] = allLobs?.data?.filter(x => listLOBPermitted.includes(x.lobCode)) ?? [];
        const parms = {
            filters: selected.pn ? [selected.pn] : selected.pd,
            filterType: selected.pn ? '1' : '3',
            lobs: selLOBS
        };

        await SearchPartNumbers(parms, current => {
            if (current?.data) {
                updatePn(current.data.map((e: OrderItemsDTO) => ({ ...e, quantity: 0 })));
            }
        });
    };

    const handleGetPartNumbers = async (): Promise<void> => {
        setLoading(true);

        await getOptions(undefined, resp => {
            updateProducts(
                resp.data?.map((e: any, index: number) => ({
                    value: index,
                    text: e.name
                }))
            );
        });
        setLoading(false);
    };

    const validate = (): boolean => {
        return !!selected.pd || !!selected.pn;
    };

    const itemInCart = (): JSX.Element => {
        return(
            <Modal
                className="modalW600"
                onClose={() => setModalStateQuantity(false)}
                size="small"
                open={modalStateQuantity}
                closeOnDimmerClick={true}
                closeOnDocumentClick={true}
            >
                <div className="modalConsultWaranty">
                    {resultList?.data?.map((e: OrderItemsDTO) => (
                    <>
                        <Modal.Header>
                            <div className="modalHeader">
                                <h2>{t('common:translation.Atention').toUpperCase()}</h2>
                            </div>
                        </Modal.Header>
                        <div>
                            <div className="container-selects">
                                <h3>Part number já existe no carrinho. Se deseja adicionar mais unidades, informe no campo abaixo.</h3>
                                <Input
                                    label={t('common:actions.AddExtraQuantity')}
                                    type="number"
                                    min={1}
                                    onChange={(value: any) => {
                                        const qtd = parseInt(value);
                                        setNewQtd(isNaN(qtd) ? 0 : qtd);
                                    }}
                                    value={newQtd.toString()}
                                />
                            </div>
                            <Card.Footer>
                                <div className="buttonModal">
                                    <Button
                                        content={t('common:actions.Close')}
                                        type="secondary"
                                        onClick={() => {
                                            e.quantity = 0; 
                                            setNewQtd(0);
                                            setModalStateQuantity(false)}}  
                                        size="medium"
                                    />
                                    <Button 
                                        type="primary"  
                                        icon="slidercontrols-plus" 
                                        disabled={!newQtd || newQtd <= 0 || loadingAdd}
                                        onClick={() => alterQuantity(e)}
                                        content={t('common:actions.Save')}
                                        iconPosition="right"
                                        loading={loadingAdd}
                                    />
                                </div>
                            </Card.Footer>
                        </div>
                    </>
                    ))};
                </div>
            </Modal>
        )
    };
    
    const alterQuantity = async (e: OrderItemsDTO) => {
        await addItemInCart(e, current => {
            if (current.data) {
                setdefaultCart(old => ({
                    ...old,
                    orderItems: [...(old?.orderItems ?? []).map(item => item.partNumber === current.data?.partNumber?{
                        ...item,
                        quantity: item.quantity + newQtd
                    } : item)]
                }));
                e.quantity = 0;
                setNewQtd(0);
                setModalStateQuantity(false);  
            }
        });
    };

    const addItemCart = async (e: OrderItemsDTO) => {
        e.email = user?.email ? user?.email : '';
        await addItemInCart(e, current => {
            if(defaultCart.orderItems != null){
                for(var item of defaultCart?.orderItems){
                    console.log(item.partNumber)
                    if(item.partNumber == current.data?.partNumber){
                        setModalStateQuantity(true);
                        return;
                    }
                }
            }
            if (current.data) {
                current.data.partNumber = current.data.code;
                setdefaultCart(old => ({
                    ...old,
                    orderItems: [...(old?.orderItems ?? []), current.data!]
                }));
                e.quantity = 0;
            }
        });
    };

    const limparFiltro = () => {
        setSelected({ pn: '', pd: [] });
    };

    const getImages = async (partNumbers: string[]): Promise<void> => {
        try {
            const startTime = performance.now(); // Log de depuração para medir o retorno do Back. Deverá ser tirado depois.
            await fetchImages(partNumbers, resp => {
                const endTime = performance.now(); // Log de depuração para medir o retorno do Back. Deverá ser tirado depois.
                const duration = endTime - startTime;
                const imagesResponse = resp.data;
                const newImagesMap: { [key: string]: string[] } = {};

                let allImagesEmpty = true;

                imagesResponse.forEach((imageData: any) => {
                    if (imageData.partNumber && Array.isArray(imageData.images)) {
                        if (imageData.images.length > 0) {
                            newImagesMap[imageData.partNumber] = imageData.images;
                            allImagesEmpty = false;
                        }
                    }
                });

                if (Object.keys(newImagesMap).length > 0) {
                    setImagesMap(prev => ({ ...prev, ...newImagesMap }));
                }

                setCarregaImagem(false);
            });
        } catch (error) {
            setNotification({
                type: 'critical',
                message: t('notification:critical.ErroImage')
            });
        }
    };

    useEffect(() => {
        if (carregaImagem && resultList?.data?.length) {
            const partNumbers = resultList.data.map(item => item?.code ?? 'sem partNumber');
            getImages(partNumbers);
        }
    }, [carregaImagem, resultList]);

    useEffect(() => {
        setCarregaImagem(true);
    }, [resultList]);

    const openImageModal = (partNumber: string) => {
        const imgs = imagesMap[partNumber] || [];
        setImages(imgs);
        setCurrentImageIndex(0);
        setIMGModalVisible(true);
    };

    const renderIMGModal = () => {
        if (!imgModalVisible) return null;

        return (
            <div className="overlay-wrapper">
                <div className="overlay" onClick={() => setIMGModalVisible(false)}>
                    {images.length > 0 ? (
                        <div className="carousel-container" onClick={e => e.stopPropagation()}>
                            <img
                                src={`data:image/jpeg;base64,${images[currentImageIndex]}`}
                                alt={`Imagem ${currentImageIndex + 1} de ${images.length}`}
                                className="image-carousel"
                                onLoad={() => setImageLoading(false)}
                                onError={() => setImageLoading(false)}
                            />
                            <div className="carousel-controls">
                                <button
                                    className="chevron-left"
                                    disabled={currentImageIndex === 0}
                                    onClick={() => {
                                        setCurrentImageIndex(prev => Math.max(prev - 1, 0));
                                        setImageLoading(true);
                                    }}
                                >
                                    ◀
                                </button>
                                <button
                                    className="chevron-right"
                                    disabled={currentImageIndex === images.length - 1}
                                    onClick={() => {
                                        setCurrentImageIndex(prev => Math.min(prev + 1, images.length - 1));
                                        setImageLoading(true);
                                    }}
                                >
                                    ▶
                                </button>
                            </div>
                        </div>
                    ) : (
                        <p className="WarningNotImage">{t('common:translation.NoImages')}</p>
                    )}
                </div>
            </div>
        );
    };

    return (
        <>
            {imgModalVisible && renderIMGModal()}
            {renderModal()}
            {itemInCart()}
            <div>
                <span>
                    <h1>
                        <Icon root="common" name="device-add" size="large" /> {t('common:actions.Add')}
                    </h1>
                    <div className="div-shipping-os">
                        <Icon root="common" name="shipping" color="blue" size="xlarge" />

                        <h5>{t('productinfots.FreeShipping')}</h5>
                        <div>
                            <Button type="secondary" onClick={() => setModalState(true)}>
                                {t('productinfots.ConditionsYourRegion')}
                            </Button>
                        </div>
                    </div>

                    <div className="form3Columns">
                        <Select
                            label={t('common:translation.Product')}
                            disabled={loading}
                            options={products?.data ?? []}
                            placeholder={loading ? t('common:actions.Loading') : t('common:translation.Product')}
                            value={selected.pd
                                .map(pdText => products?.data?.findIndex((x: any) => x.text === pdText))
                                .filter(idx => idx !== -1)}
                            search={true}
                            multiple={true}
                            onChange={indexes => {
                                const selectedTexts = indexes.map((i: number) => products?.data![i].text);
                                setSelected(prev => ({ ...prev, pd: selectedTexts, pn: '' }));
                            }}
                        />

                        <Select
                            label={t('common:translation.PartNumber')}
                            options={partNumbers ?? []}
                            disabled={loading}
                            value={selected.pn && partNumbers?.findIndex((x: ProductsDTO) => x.text == selected.pn)}
                            search={true}
                            placeholder={loading ? t('common:actions.Loading') : t('common:translation.PartNumber')}
                            onChange={e => {
                                setSelected(prev => ({ ...prev, pn: partNumbers![e].text, pd: [] }));
                            }}
                        />
                    </div>

                    <div className="buttonsSearch">
                        <Button
                            type="secondary"
                            icon="badge-delete"
                            loading={loadAction}
                            disabled={!validate() || loadAction}
                            content={t('common:actions.ResetFilters')}
                            onClick={() => limparFiltro()}
                        />
                        <Button
                            type="primary"
                            icon="search"
                            loading={loadAction}
                            disabled={!validate() || loadAction}
                            content={t('common:actions.Search')}
                            onClick={() => handleSearch()}
                        />
                    </div>

                    <div style={{ maxHeight: '60vh', overflowY: 'scroll' }}>
                        {!!resultList?.data?.length && (
                            <Table>
                                <Table.Header>
                                    <Table.HeaderCell>{t('cart.Image')}</Table.HeaderCell>
                                    <Table.HeaderCell>{t('cart.Item')}</Table.HeaderCell>
                                    <Table.HeaderCell>{t('cart.Discount')}</Table.HeaderCell>
                                    <Table.HeaderCell>{t('cart.NetPrice')}</Table.HeaderCell>
                                    <Table.HeaderCell>{t('cart.Quantity')}</Table.HeaderCell>
                                    <Table.HeaderCell>{''}</Table.HeaderCell>
                                </Table.Header>
                                <Table.Body>
                                    {resultList?.data?.map((item: OrderItemsDTO, index) => (
                                        <React.Fragment key={item.id}>
                                            <Table.Row className="clickable">
                                                <Table.Cell onClick={() => openImageModal(item.code!)}>
                                                    {imagesMap[item.code!]?.length > 0 ? (
                                                        <Carousel
                                                            className="carouselcart"
                                                            autoPlay={true}
                                                            transitionTime={6000}
                                                            height={200}
                                                            showArrows={false}
                                                        >
                                                            {imagesMap[item.code!].map((image: string, idx: number) => (
                                                                <Carousel.Slide
                                                                    key={idx}
                                                                    className="carousel-image"
                                                                    image={`data:image/png;base64,${image}`}
                                                                    showArrows={false}
                                                                />
                                                            ))}
                                                        </Carousel>
                                                    ) : (
                                                        <img
                                                            className="imagepd"
                                                            alt="imagem padrão"
                                                            src={require('../../../../../assets/HON192.png')}
                                                        />
                                                    )}
                                                </Table.Cell>
                                                <Table.Cell>
                                                    <h4>{item?.code}</h4>
                                                    {item?.description}
                                                </Table.Cell>
                                                <Table.Cell>{item?.discount * 100}%</Table.Cell>
                                                <Table.Cell>{'US$ ' + item.netPrice}</Table.Cell>
                                                <Table.Cell>
                                                    <Input
                                                        helperText="QTD"
                                                        type="number"
                                                        min={1}
                                                        onChange={(value: any) => {
                                                            item.quantity = parseInt(value);
                                                            setNewQtd(item.quantity);
                                                        }}
                                                        value={item.quantity.toString()}
                                                    />
                                                </Table.Cell>
                                                <Table.Cell>
                                                    <div className="buttonsSearch">
                                                        <Button
                                                            loading={loadingAdd}
                                                            disabled={!item.quantity}
                                                            content={t('common:actions.Add')}
                                                            onClick={() => addItemCart(item)}
                                                        />
                                                    </div>
                                                </Table.Cell>
                                            </Table.Row>
                                        </React.Fragment>
                                    ))}
                                </Table.Body>
                            </Table>
                        )}
                    </div>
                </span>
                <MyCart />
            </div>
        </>
    );
}
export default AddEquipment;
